import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Box, TextField, Typography} from '@mui/material';
import {CustomButton, Layout, PageHeader} from '../components';
import {useState} from 'react';
import PersonIcon from '@mui/icons-material/Person';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AdminModal from '../components/Modals/AdminModal';
import {useDispatch} from 'react-redux';
import {
  clearAuthError,
  errorToast,
  getMyProfile,
  successToast,
} from '../actions';
import {useSelector} from 'react-redux';
import UpdatePasswordModal from '../components/Modals/UpdatePasswordModal';
import EmailIcon from '@mui/icons-material/Email';
import {useFormInput} from '../utils/utilities';
import {fieldError, isFieldIvalid} from '../utils/errorHandler';
import {updateEmailApi} from '../api/users.service';

const EditProfile = () => <AdminModal profile />;
const ChangePassword = () => <UpdatePasswordModal changePassword />;

const ChangeEmail = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {user} = useSelector(s => s.user);
  const [error, setError] = useState('');
  const email = useFormInput(user.email);
  const onSubmit = e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    updateEmailApi(email.value)
      .then(() => {
        dispatch(successToast('Email changed successfully!'));
      })
      .catch(e => {
        setError(e.message);
        if (e.status !== 400 && e.status !== 409) {
          dispatch(errorToast(e.message));
        }
      })
      .finally(() => setLoading(false));
  };

  const errorMessage = () => {
    if (typeof error === 'string' && error !== '') {
      return error;
    } else if (isFieldIvalid(error, 'email')) {
      return fieldError(error, 'email');
    }
    return '';
  };

  return (
    <form onSubmit={onSubmit}>
      <Box
        display="flex"
        flexDirection="column"
        m="0 auto"
        mt="2rem"
        gap="2.25rem"
        sx={{
          width: {
            xs: 'calc(100vw - 4rem)',
            sm: '30rem',
          },
        }}>
        <TextField
          {...email}
          error={!!error}
          helperText={errorMessage()}
          required
          label="Email"
          fullWidth
        />
        <CustomButton loading={loading} type="submit">
          Change email
        </CustomButton>
      </Box>
    </form>
  );
};

const STEPS = {
  profile: EditProfile,
  password: ChangePassword,
  email: ChangeEmail,
};

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tab, setTab] = useState('profile');
  const {user} = useSelector(s => s.user);

  const onBack = () => navigate(-1);

  const Klass = STEPS[tab] || React.Fragment;

  const changeTab = currentTab => {
    dispatch(clearAuthError(''));
    setTab(currentTab);
  };

  useEffect(() => {
    dispatch(getMyProfile());
  }, []);

  return (
    <Layout>
      <PageHeader onBack={onBack} title="Profile" />
      <Box flex={1} display="flex">
        <Box width="300px" borderRight="1px solid rgba(0, 0, 0, 0.12)">
          <Tab
            selected={tab === 'profile'}
            text="Edit profile"
            onClick={() => changeTab('profile')}
          />
          <Tab
            selected={tab === 'password'}
            text="Change password"
            onClick={() => changeTab('password')}
          />
          <Tab
            selected={tab === 'email'}
            text="Change email"
            onClick={() => changeTab('email')}
          />
        </Box>
        {!!user && (
          <Box flex={1} display="flex" flexDirection="column">
            <Klass />
          </Box>
        )}
      </Box>
    </Layout>
  );
};

const Tab = ({selected, text, onClick}) => {
  return (
    <Box
      onClick={onClick}
      color={selected && 'white'}
      bgcolor={selected && 'rgba(0, 0, 0, 0.54)'}
      p="12px 0"
      pl="2rem"
      gap="1rem"
      display="flex"
      alignItems="center"
      sx={{cursor: 'pointer', ':hover': !selected && {bgcolor: '#f2f2f5'}}}>
      {text === 'Edit profile' ? (
        <PersonIcon />
      ) : text === 'Change password' ? (
        <LockOpenIcon />
      ) : (
        <EmailIcon />
      )}
      <Typography>{text}</Typography>
    </Box>
  );
};

export default Profile;
